import { useContext, useEffect, useRef, useState } from 'react'
import { Close } from '@styled-icons/evil'
import Button from '../../../../common/Button'
import SelectInput from '../../../../common/SelectInput'
import { useParams } from 'react-router-dom'
import { getRequest, postRequest } from '../../../../../services/base'
import { HarnessListContext } from '../../context/context'
import { NavContext } from '../../../../../context/global_context'

const DEFAULT_FORM_DATA = {
  sales_code: null,
  level: null,
  harness_type: null,
}

const HarnessSalesCodeLevelsForm = ({ getHarnessSalesCodeData }) => {
  const { vehicle } = useParams()
  const harnessLevelRef = useRef()
  const [showForm, setShowForm] = useState(false)
  const [state, dispatch] = useContext(HarnessListContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [salesCodeOptions, setSalesCodeOptions] = useState([])
  const [inputValues, setInputValues] = useState(DEFAULT_FORM_DATA)
  const [partNumberOptions, setPartNumberOptions] = useState([])
  const [harnessTypeOptions, setHarnessTypeOptions] = useState([])
  const [errorResponse, setErrorResponse] = useState([])

  useEffect(() => {
    getSalesCodeList('')
    getPartNumberList('')
    getHarnessTypeList('')
  }, [])

  const saveRelatedData = async (e) => {
    e.preventDefault()
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Saving Harness Sales Code Mapping Data',
        showLoader: true,
      },
      notification: {},
    })
    const form = e.target
    const formData = new FormData(form)
    formData.append('vehicle', vehicle)
    let res = await postRequest(
      `/api/harnesses/related_data/save/${state?.harnessSalesCodePopup?.id}/`,
      formData
    )
    if (res?.status) {
      navDispatch({
        type: 'loader',
        data: {
          caption: '',
          showLoader: false,
        },
        notification: {},
      })
      if (res?.error_response?.length) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.error_response,
          },
        })
        setErrorResponse(res)
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Mapping Successfull done.',
          },
        })
        closeRelation()
      }
      getHarnessSalesCodeData()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res.msg,
        },
      })
    }
  }

  const getSalesCodeList = async (search = '') => {
    let res = await getRequest(
      `/api/option_codes/options/?vehicle=${vehicle}&search=${search}`
    )
    setSalesCodeOptions(res.data)
  }

  const getPartNumberList = async (search = '') => {
    let res = await getRequest(
      `/api/part_number/?vehicle=${vehicle}&search=${search}`
    )
    setPartNumberOptions(res.results)
  }
  const getHarnessTypeList = async (search = '') => {
    let res = await getRequest(
      `/api/harness_type/?vehicle=${vehicle}&search=${search}`
    )
    setHarnessTypeOptions(res.results)
  }

  const closeRelation = () => {
    setShowForm(false)
    setErrorResponse({})
    setInputValues(DEFAULT_FORM_DATA)
  }

  const filterOptions = (option, searchText) => {
    if (option.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true
    } else {
      return false
    }
  }

  return (
    <div ref={harnessLevelRef}>
      <Button
        className={`cursor-pointer btn`}
        text={`New`}
        onClick={() => {
          setShowForm(true)
        }}
      />
      {showForm && (
        <div style={{ position: 'relative' }}>
          <div
            className={
              'bg-tracer-dark-blue mt-1 text-black px-2 text-white border-white border'
            }
            style={{
              position: 'absolute',
              zIndex: 100,
              right: 0,
              width: '50vw',
            }}
          >
            <div className="flex justify-end font-bold pt-1">
              <Close
                size="1.3rem"
                onClick={() => {
                  closeRelation()
                }}
                className="cursor-pointer"
              />
            </div>
            {errorResponse?.error_response?.length > 0 ? (
              <div className="text-red-400 text-base pb-5 px-2 text-center">
                <div className="text-lg font-bold text-white">
                  Following Error Found
                </div>
                {errorResponse?.error_response?.map((error, errorIndex) => {
                  return (
                    <span key={`error-${errorIndex}-${error}`}> {error} |</span>
                  )
                })}
              </div>
            ) : (
              <form
                onSubmit={(e) => {
                  saveRelatedData(e)
                }}
              >
                <div className="flex">
                  <SelectInput
                    value={inputValues.sales_code}
                    onChange={(value) => {
                      setInputValues({ ...inputValues, sales_code: value })
                    }}
                    label="Sales Code"
                    name="sales_code"
                    options={salesCodeOptions}
                    optionValue="value"
                    optionLabel="label"
                    filterOption={filterOptions}
                  />

                  <SelectInput
                    value={inputValues.harness_type}
                    onChange={(value) => {
                      setInputValues({ ...inputValues, harness_type: value })
                    }}
                    label="Harness Type"
                    name="harness_type"
                    options={harnessTypeOptions}
                    optionLabel={'name'}
                    optionValue={'id'}
                    onInputChange={(value) => {
                      if (value) {
                        getHarnessTypeList(value)
                      }
                    }}
                  />
                </div>
                <div className="flex">
                  <SelectInput
                    value={inputValues.level}
                    onChange={(value) => {
                      setInputValues({ ...inputValues, level: value })
                    }}
                    label="Part Number"
                    name="part_number"
                    options={partNumberOptions}
                    optionLabel={'name'}
                    optionValue={'id'}
                    onInputChange={(value) => {
                      if (value) {
                        getPartNumberList(value)
                      }
                    }}
                    isMulti={true}
                  />
                </div>

                <div className="flex justify-end py-4 px-2">
                  <Button
                    className={`cursor-pointer btn`}
                    text={`Save Mapping`}
                    onClick={() => {}}
                  />
                </div>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default HarnessSalesCodeLevelsForm
